/* eslint-disable no-prototype-builtins */
import React, { useState, useEffect } from 'react'
import { useNavigate, useParams, useLocation } from 'react-router-dom'
import axios from 'axios'
import { Link } from 'react-router-dom'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import IconButton from '@mui/material/IconButton'
import AddIcon from '@mui/icons-material/Add'
import FilterAltIcon from '@mui/icons-material/FilterAlt'
import ReplayIcon from '@mui/icons-material/Replay'
import RefreshIcon from '@mui/icons-material/Refresh'
import CheckIcon from '@mui/icons-material/Check'

import EditProfile from './EditProfile'
import Onboarding from '../../onboarding/Onboarding'

import useWindowDimensions from '../../../helpers/windowDimensions'
import { standardButton, exitModalIconButton } from '../../../helpers/buttons'
import { standardSpinner } from '../../../helpers/spinners'
import { getPayload, getTokenFromLocalStorage, userIsAuthenticated, getEmailFromLocalStorage } from '../../../helpers/storage'
import { profilesSortByArray, positionChangeWidthSm, positionChangeWidthMd, swipelyticsPink, swipelyticsTurquoise, navbarHeight, footerHeight, dashboardNavbarHeight, newProfileRequirementsChecklist, profileTypes, minimumBumbleAboutMe, minimumBumbleHobbies, minimumBumbleMedia, minimumBumblePrompts, minimumHingeAboutMe, minimumHingeHobbies, minimumHingeMedia, minimumHingePrompts, minimumTinderAboutMe, minimumTinderHobbies, minimumTinderMedia, minimumTinderPrompts, minimumOnboardingMedia, minimumOnboardingAboutMe, minimumOnboardingHobbies, minimumOnboardingPrompts } from '../../../helpers/variableDefaults'
import { selectSortCategory } from '../../../helpers/selects'
import { couldNotLoadPageError } from '../../../helpers/errors'
import { switchWithTitle } from '../../../helpers/switches'
import { modifyInDatabase } from '../../../helpers/modifyInDatabase'
import { seoPageTags, customAnalyticsEvent } from '../../../helpers/analytics'
import { searchTextField } from '../../../helpers/textfields'
import { standardPagination } from '../../../helpers/pagination'
import { reloadView, numberWithCommas } from '../../../helpers/globalHelpers'
import { advisoryTypography, faqTextTypography } from '../../../helpers/typographies'
import { videoInsert } from '../../../helpers/videos'
import { selectElementString, selectElement, selectMultiple } from '../../../helpers/selects'
import { standardErrorContainer } from '../../../helpers/errors'
import { requiredVitalInfoExists, newProfileCriteriaIsMet } from '../../../helpers/commonMethods'

// Dashboard Page
const ProfileOverview = (props) => {

  const { isDemo, demoUser } = props
  
  // Window Dimensions
  const { height, width } = useWindowDimensions()

  // URL Path
  const urlPath = window.location.pathname
  // console.log('urlPath ->', urlPath)
  
  // Navigate
  const navigate = useNavigate()
  const location = useLocation()
  const previousProfileType = 'state' in location && location.state !== null && location.state !== undefined && 'previousProfileType' in location.state ? location.state.previousProfileType : 'Hinge'

  // Params
  const { userId } = useParams()

  // Payload
  const payload = getPayload()

  // User
  const [user, setUser] = useState({})

  // Sorting
  const [profileType, setProfileType] = useState(previousProfileType)
  const [datingProfile, setDatingProfile] = useState({}) 
  const [previousDatingProfile, setPreviousDatingProfile] = useState({})

  // Loading
  const [loading, setLoading] = useState(false)

  // Errors
  const [errors, setErrors] = useState(false)

  // UseEffect — Send to user profile view if User is not a Person in the estate
  useEffect(() => {

    if (isDemo) {
      setUser({ ...demoUser })
      setPreviousDatingProfile({ ...demoUser.datingProfiles.filter(datingProfile => datingProfile.type.toLocaleLowerCase() === profileType.toLocaleLowerCase())[0] })
      setDatingProfile({ ...demoUser.datingProfiles.filter(datingProfile => datingProfile.type.toLocaleLowerCase() === profileType.toLocaleLowerCase())[0] })
    } else if (!userIsAuthenticated()) {
      navigate('/login')
    } else if (userId !== payload.sub) {
      navigate(`/dashboard/${payload.sub}`)
      // reloadView()
    } else {
      const getData = async () => {
        setLoading(true)
        try {
          const { data: retrievedUser } = await axios.get(`${process.env.REACT_APP_SERVER_URL}/api/users/${payload.sub}`, {
            headers: {
              Authorization: `Bearer ${getTokenFromLocalStorage()}`,
            },
          })
          // console.log('retrieved User ->', retrievedUser)

          if (payload.sub === retrievedUser._id) {
            // Set States
            setUser(retrievedUser)
            setPreviousDatingProfile({ ...retrievedUser.datingProfiles.filter(datingProfile => datingProfile.type.toLocaleLowerCase() === profileType.toLocaleLowerCase())[0] })
            setDatingProfile({ ...retrievedUser.datingProfiles.filter(datingProfile => datingProfile.type.toLocaleLowerCase() === profileType.toLocaleLowerCase())[0] })
            
            setErrors(false)
            setLoading(false)
          } else {
            navigate(`/`)
            setErrors(false)
            setLoading(false)
          }

        } catch (error) {
          // console.log(error)

          navigate(`/`)

          setErrors(true)
          setLoading(false)
        }
      }

      getData()
    }

  }, [])

  useEffect(() => {
    // console.log('useEffect Runs')
    // console.log('filtersObj ->', filtersObj)
    // console.log('profileCreated ->', profileCreated)
    // console.log('openNewProfileModal ->', openNewProfileModal)

    // Setting the new Current Profile
    // console.log('new profile type ->', profileType)
    if (
      user 
      && 'datingProfiles' in user 
      && datingProfile 
      && 'type' in datingProfile
      && datingProfile.type.toLowerCase() !== profileType.toLowerCase()
    ) {
      // console.log('datingProfile should change')
      setPreviousDatingProfile({ ...user.datingProfiles.filter(datingProfile => datingProfile.type.toLocaleLowerCase() === profileType.toLocaleLowerCase())[0] })
      setDatingProfile({ ...user.datingProfiles.filter(datingProfile => datingProfile.type.toLocaleLowerCase() === profileType.toLocaleLowerCase())[0] })
      
      // if (isDemo) {
      navigate(`${urlPath}`, { state: { previousProfileType: profileType } })
      // } else {
      //   navigate(`/dashboard/${userId}`, { state: { previousProfileType: profileType } })
      // }
    }

  }, [profileType])

  useEffect(() => {
    // console.log('useEffect Runs')
    // console.log('filtersObj ->', filtersObj)
    // console.log('profileCreated ->', profileCreated)
    // console.log('openNewProfileModal ->', openNewProfileModal)
    // console.log('newDatingProfile ->', datingProfile)

  }, [datingProfile])

  const checklistItemJSX = (checklistItemIndex, checklistItem, width, isFinished, isCurrent) => {

    return (
      <Box
        key={checklistItemIndex}
        sx={{
          my: 1,
          width: '100%',
          display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'flex-start',
        }}
      >
        {/* Icon, Checklist Item */}
        <Box
          sx={{
            width: '100%',
            display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center',
          }}
        >
          {isFinished ?
            <CheckIcon 
              fontSize='large'
              sx={{
                color: isFinished ? 'darkolivegreen' : isCurrent ? 'dodgerblue' : 'black',
                border: 2, borderRadius: '50%', boxShadow: 3, borderColor: isFinished ? 'darkolivegreen' : isCurrent ? 'dodgerblue' : 'black',
              }}
            />
            :
            <Box 
              sx={{
                width: '35px', height: '35px',
                border: 2, borderRadius: '50%', boxShadow: 3, borderColor: isCurrent ? 'dodgerblue' : 'black',
              }}
            />
          }
          <Typography
            sx={{
              fontWeight: 'bold',
              fontSize: '18px',
              ml: 2,
              color: isFinished ? 'darkolivegreen' : isCurrent ? 'dodgerblue' : 'black',
            }}
          >
            {checklistItem.toDo}
          </Typography>
        </Box>

        {/* Description */}
        {!isFinished &&
          <Box
            sx={{
              my: 2,
              width: '100%',
              display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start',
            }}
          >
            {checklistItem.description.length > 0 && faqTextTypography(checklistItem.description, '18px', 'Lato')}
            {checklistItem.videoURL.length > 0 && videoInsert(checklistItem.videoURL, checklistItem.toDo, '95%', width)}
            {checklistItem.writtenInstructions.length > 0 && checklistItem.description.length === 0 && faqTextTypography(checklistItem.writtenInstructions, '18px', 'Lato')}
          </Box>
        }

      </Box>
    )
  }

  return (
    <>
      {/* Helmet — for analytics, seo, and page title changing */}
      {seoPageTags(
        `My Profiles`
      )}

      {/* Body */}
      {loading || !user || Object.keys(user).length === 0 || !user.hasOwnProperty('_id') ?
        <Box sx={{ 
          width: '100%',
          // minHeight: `calc(100vh - ${navbarHeight} - ${footerHeight} - ${dashboardNavbarHeight})`,
          minHeight: `calc(100vh - ${navbarHeight} - ${dashboardNavbarHeight})`,
          mt: 0, mb: 0,
          display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', 
        }}>
          {standardSpinner()}
        </Box>
        :
        errors ? 
          <Box
            sx={{
              // backgroundColor: 'yellow',
              width: '100%',
              minHeight: `calc(100vh - ${navbarHeight} - ${footerHeight} - ${dashboardNavbarHeight})`,
              display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', 
            }}
          >
            {couldNotLoadPageError()}
          </Box>
          :
          <Box
            sx={{
              // backgroundColor: 'green',
              pt: 3, pb: 4,
              width: '100%',
              minHeight: `calc(100vh - ${navbarHeight} - ${footerHeight} - ${dashboardNavbarHeight})`,
              display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center',
            }}
          > 
            <>
              {/* Inactive Subscription */}
              {user.hasOwnProperty('subscriptionIsActive') && !user.subscriptionIsActive &&
                <Box
                  sx={{
                    backgroundColor: 'red',
                    color: 'white',
                    py: 3, px: 3,
                    width: '100%', 
                    // height: '100px',
                    fontSize: '18px', fontWeight: 'bold',
                    display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center',
                  }}
                >
                  {`Click 'Manage Subscription' in the 'Settings' tab to reactivate subscription`}
                </Box>
              }

              {/* Profiles */}
              {!user.hasOwnProperty('datingProfiles') || !newProfileCriteriaIsMet(user) || user.datingProfiles.length === 0 ?
                <>
                  <Box
                    sx={{
                      // backgroundColor: 'whitesmoke',
                      // mt: 2,
                      // px: 2, py: 1,
                      // boxShadow: 3, borderRadius: 3,
                      // width: '95%', maxWidth: '600px',
                      display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center',
                    }}
                  >

                    <Onboarding user={user} setUser={setUser} />

                  </Box>
                </>
                :
                <Box sx={{ mt: 0, mb: 2, width: '100vw', maxWidth: '600px', minWidth: '250px', display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center' }}>
                  
                  {/* Select Profile Type */}
                  <Box
                    sx={{
                      mt: width < positionChangeWidthSm ? 1 : 1,
                      mb: width < positionChangeWidthSm ? 1 : 1,
                      width: '190px', 
                      maxWidth: positionChangeWidthSm,
                      display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center',
                    }}
                  >
                    {selectElementString('type', 'Type', profileType, false, true, 'lg', profileTypes, setProfileType)}
                  </Box>


                  {/* Edit Profile */}
                  <EditProfile isDemo={isDemo} user={user} setUser={setUser} datingProfile={datingProfile} setDatingProfile={setDatingProfile} previousDatingProfile={previousDatingProfile} setPreviousDatingProfile={setPreviousDatingProfile} profileType={profileType.toLowerCase()} />
                  
                </Box>
              } 
            </>
          </Box>
      }
    </>
  )
}

export default ProfileOverview